export const announcements = {
  'nav.announcements': 'الإعلانات',
  'settings.feature.announcements': 'الإعلانات',
  'settings.feature.announcements.desc': 'إعلانات المدرسة لأولياء الأمور والطلاب والموظفين في التطبيق، مع معرفة من قرأها',
  'announcements.title': 'الإعلانات',
  'announcements.subtitle': 'رسائل المدرسة لأولياء الأمور والطلاب والموظفين، ومن قرأها',
  'announcements.new': 'إعلان جديد',
  'announcements.empty': 'لا توجد إعلانات',
  'announcements.emptyBody': 'اكتب إعلاناً فيصل إلى أولياء الأمور في التطبيق، وترى من قرأه.',
  'announcements.more': 'عرض المزيد',
  'announcements.filter.ALL': 'الكل',
  'announcements.status.PUBLISHED': 'مُرسل',
  'announcements.status.SCHEDULED': 'مجدول',
  'announcements.status.WITHDRAWN': 'مسحوب',
  'announcements.audience.PARENT': 'أولياء الأمور',
  'announcements.audience.STUDENT': 'الطلاب',
  'announcements.audience.STAFF': 'الموظفون',
  'announcements.audience1.PARENT': 'ولي أمر',
  'announcements.audience1.STUDENT': 'طالب',
  'announcements.audience1.STAFF': 'موظف',
  'announcements.and': ' و',
  'announcements.scope.SCHOOL': 'المدرسة كلها',
  'announcements.scope.GRADES': 'مراحل محددة',
  'announcements.scope.CLASSES': 'شعب محددة',
  'announcements.pinned': 'مثبّت',
  'announcements.scheduledFor': 'يُرسل {at}',
  'announcements.withdrawnAt': 'سُحب {at}',
  'announcements.readOf': 'قرأه {read} من {total}',
  'announcements.readAt': 'قرأه {at}',
  'announcements.read': 'قرأوه',
  'announcements.unread': 'لم يقرؤوه',
  'announcements.recipients': 'المستلمون',
  'announcements.noRecipients': 'لم يصل لأحد: لا يوجد مستلمون لديهم حساب في التطبيق.',
  'announcements.edit': 'تعديل',
  'announcements.pin': 'تثبيت في الأعلى',
  'announcements.unpin': 'إلغاء التثبيت',
  'announcements.withdraw': 'سحب الإعلان',
  'announcements.withdrawTitle': 'سحب هذا الإعلان؟',
  'announcements.withdrawBody': 'يختفي من التطبيق عند جميع المستلمين. يبقى محفوظاً هنا.',
  'announcements.cancel': 'إلغاء الإرسال',
  'announcements.cancelTitle': 'إلغاء هذا الإعلان المجدول؟',
  'announcements.cancelBody': 'لن يُرسل. يبقى محفوظاً هنا.',
  'announcements.withdrawn': 'سُحب الإعلان.',
  'announcements.sent': 'أُرسل الإعلان.',
  'announcements.scheduled': 'جُدول الإعلان.',
  'announcements.compose.title': 'إعلان جديد',
  'announcements.compose.editTitle': 'تعديل الإعلان المجدول',
  'announcements.compose.subject': 'العنوان',
  'announcements.compose.body': 'نص الإعلان',
  'announcements.compose.bodyHint': 'متبقٍ {n} حرف.',
  'announcements.compose.to': 'إلى',
  'announcements.compose.studentsHint': 'من لديه حساب طالب',
  'announcements.compose.which': 'أي العائلات',
  'announcements.compose.parentsHint': 'يصل لأولياء الأمور الذين لديهم حساب في التطبيق.',
  'announcements.compose.noClasses': 'لا توجد شعب مسندة إليك هذه السنة.',
  'announcements.compose.pin': 'تثبيت في أعلى الإعلانات',
  'announcements.compose.pinHint': 'للتعليمات المهمة التي يجب أن تبقى ظاهرة.',
  'announcements.compose.later': 'إرسال في وقت لاحق',
  'announcements.compose.date': 'التاريخ',
  'announcements.compose.time': 'الساعة',
  'announcements.compose.send': 'إرسال',
  'announcements.compose.schedule': 'جدولة',
  'announcements.issue.title': 'اكتب عنواناً.',
  'announcements.issue.body': 'اكتب نص الإعلان.',
  'announcements.issue.audience': 'اختر من يستلم الإعلان.',
  'announcements.issue.grades': 'اختر المراحل.',
  'announcements.issue.classes': 'اختر الشعب.',
  'announcements.issue.schedule': 'اختر تاريخ الإرسال وساعته.',
} as const;
